import areasService from '@/api/areas'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  actions: {
    async getAreas() {
      try {
        const response = await areasService.getAreas()
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async saveArea({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await areasService.saveArea(payload)
        dispatch('Global/showMessage', 'addAreaSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
        throw error
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async editArea({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await areasService.editArea(payload)
        dispatch('Global/showMessage', 'editAreaSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
        throw error
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async removeArea({ dispatch }, areaId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await areasService.removeArea(areaId)
        dispatch('Global/showMessage', 'areaSuccessfullyDeleted', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    }
  }
}